export default __webpack_public_path__ + "static/media/CircularStd-Medium.6fb73f93.ttf";